
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { router } from './Router/Routes';
import { Toaster } from 'react-hot-toast';
import Particles from 'react-particles-js';
import { particles } from './particles/Particles';



function App() {

  return (
    <div className='App' style={{ position: 'relative', overflow: "hidden" }}>
      <div style={{ position: 'absolute' }}>
        <Particles style={{
          width: '100vh',
          heigth: '100%'
        }} params={{
          "particles": {
            "number": {
              "value": 100,
              "density": {
                "enable": false
              }
            },
            "size": {
              "value": 10,
              "random": true
            },
            "move": {
              "direction": "bottom",
              "out_mode": "out"
            },
            "line_linked": {
              "enable": false
            }
          },
          "interactivity": {
            "events": {
              "onclick": {
                "enable": true,
                "mode": "remove"
              }
            },
            "modes": {
              "remove": {
                "particles_nb": 10
              }
            }
          }
        }} />
      </div>
      <RouterProvider router={router}></RouterProvider>
      <Toaster position="top-center" reverseOrder={false}></Toaster>

    </div>
  );
}

export default App;
